import React, { useState } from 'react'
import { UiCol, UiRowContainer, UiSingleContainer, UiSingleRow } from "../../components/grid-container/GridContainer"

import {
    UiContentWr,
    UiTopInputWr,
    UiTopInputHeading,
    UiContentCol,
    UiContentColWithSlider,
    UiColTitleWr,
    UiColTitle,
    UiViewAll,
    UiTabContentWr,
    UiTabContent,
    UiContentLoyaltyPointCol
} from "../../components/common/UiPageElements"
import UiMainWrapper from "../../components/common/UiMainWrapper"
import TopHeader from "../../components/header/TopHeader"
import Footer from "../../components/footer/Footer"
import LoyaltyHomeBanner from "./Views/LoyaltyHomeBanner"
import HowLoyaltyWorks from "./Views/HowLoyaltyWorks"
import { TermsAndConditions } from './Views/TermsAndConditions'
import LoyaltySignUp from "./Views/LoyaltySignUp"
import StoresWithCanEarnPoints from "./Views/StoresWithCanEarnPoints"
import StoresWithAlreadyEarnPoints from "./Views/StoresWithAlreadyEarnPoints"
import {LoyaltyPointsEarned} from "./Views/LoyaltyPointsEarned"
import AnnualSale from "../../../../styles/img/annual-sale.png"

export default function LoyaltyHomeSignedUp(props) {

    return (
        <>

            <UiMainWrapper>
                <TopHeader />
                <LoyaltyHomeBanner />

                <UiContentWr>
                    <UiRowContainer fluid="fluid" >
                        <UiCol lg="12" xl="12">
                            <UiContentCol>
                                <HowLoyaltyWorks />
                            </UiContentCol>
                        </UiCol>
                    </UiRowContainer>
                </UiContentWr>
                <UiContentWr>
                    <UiRowContainer fluid="fluid" >
                        <UiCol lg="12" xl="12">
                            <UiContentColWithSlider>
                                <UiColTitleWr>
                                    <UiColTitle
                                        title="Stores where you can earn loyalty points"
                                        subtitle="10,442 Carefully Selected Stores" />
                                    <UiViewAll className="sb-view-all-margin" />
                                </UiColTitleWr>
                                <StoresWithCanEarnPoints />
                            </UiContentColWithSlider>
                        </UiCol>
                    </UiRowContainer>
                </UiContentWr>
                <UiContentWr>
                    <UiRowContainer fluid="fluid" >
                        <UiCol lg="12" xl="12">
                            <UiContentCol>
                                <UiColTitleWr>
                                    <UiColTitle
                                        title="Stores you've earned with"
                                        subtitle="276 purchases" />
                                    <UiViewAll className="sb-loyalty-view-all-margin" />
                                </UiColTitleWr>
                                <StoresWithAlreadyEarnPoints />
                            </UiContentCol>
                        </UiCol>
                    </UiRowContainer>
                </UiContentWr>
               
                <UiContentWr>
                    <UiRowContainer fluid="fluid" >
                        <UiCol lg="9" xl="9">
                            <UiContentLoyaltyPointCol>
                                <UiColTitleWr>
                                    <UiColTitle
                                        title="Loyalty points earned"
                                        subtitle="34 stores" />
                                </UiColTitleWr>
                                <LoyaltyPointsEarned/>
                            </UiContentLoyaltyPointCol>
                        </UiCol>
                        <UiCol lg="3" xl="3">
                            <UiContentLoyaltyPointCol>
                                <img src={AnnualSale}/>
                            </UiContentLoyaltyPointCol>
                        </UiCol>
                    </UiRowContainer>
                </UiContentWr>
                <UiContentWr>
                    <UiRowContainer fluid="fluid" >
                        <UiCol lg="12" xl="12">
                            <TermsAndConditions />
                        </UiCol>
                    </UiRowContainer>
                </UiContentWr>

                <Footer />

            </UiMainWrapper>
        </>
    )
}



